import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from "chart.js";
import { isEqual } from "lodash";
import moment from "moment";
import React, { useMemo, useState } from "react";
import { Button, Card } from "react-bootstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Line } from "react-chartjs-2";
import SVG from "react-inlinesvg";
import { shallowEqual, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { YYYY_MM_DD_HH_MM_SS } from "../../../utils/const";
import {
  customRangeReportWithoutDays,
  stringToDateWithFormat
} from "../../../utils/utils";
import { useTransactionsReportUIContext } from "../Transactions Report/TransactionsReportUIContext";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const initialValues = {
  transactionDate: "thismonth",
  dateFilterLabel: "This Month"
};

const TransactionsReportChart = () => {
  const transactionsReportUIContext = useTransactionsReportUIContext();
  const transactionsReportUIProps = useMemo(() => {
    return {
      queryParamsChart: transactionsReportUIContext.queryParamsChart,
      setQueryParamsChart: transactionsReportUIContext.setQueryParamsChart
    };
  }, [transactionsReportUIContext]);

  const [chartFilter, setChartFilter] = useState(initialValues);
  const { currentState } = useSelector(
    (state) => ({ currentState: state.transactionsReport }),
    shallowEqual
  );
  const { chartEntities, chartLoading } = currentState || {};

  const { revenue, transactions } = chartEntities || {};
  const { data, labels } = revenue || {};
  const { data: dataTransactions } = transactions || {};

  const datas = {
    labels,
    datasets: [
      {
        label: "Transactions",
        data: dataTransactions,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)"
      },
      {
        label: "Revenue",
        data: data,
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)"
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top"
      },
      title: {
        display: true,
        text: "Transactions Vs Revenue"
      }
    }
  };

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(
      transactionsReportUIProps.queryParamsChart,
      values
    );
    if (!isEqual(newQueryParams, transactionsReportUIProps.queryParamsChart)) {
      transactionsReportUIProps.setQueryParamsChart(newQueryParams);
    }
  };

  const prepareFilter = (queryParams, values) => {
    const { transactionDate } = values;
    const newQueryParams = { ...queryParams };
    const filter = {};

    filter.transactionDate =
      transactionDate !== "" ? transactionDate : undefined;

    newQueryParams.filter = filter;
    return newQueryParams;
  };

  return (
    <Card className="card-custom card-stretch make-payment-wrapper mb-4">
      <Card.Header className="align-items-center border-bottom mt-4  d-lg-flex">
        <h3 className="card-title align-items-start flex-column">
          <span className="font-weight-bold text-dark">
            Transactions Statistics
          </span>
        </h3>
        <DateRangePicker
          onApply={(event, picker) => {
            const { chosenLabel } = picker || {};
            const fromDate = picker.startDate._d.toISOString();
            const endDate = picker.endDate._d.toISOString();
            let label = chosenLabel;
            if (label === "Today") {
              label = "today";
            }
            if (label === "Yesterday ") {
              label = "yesterday";
            }
            if (label === "Last 7 Days") {
              label = "last7days";
            }
            if (label === "Last 30 Days") {
              label = "last30days";
            }
            if (label === "This Week") {
              label = "thisweek";
            }
            if (label === "This Month") {
              label = "thismonth";
            }
            if (label === "This Year") {
              label = "thisyear";
            }
            if (label === "Custom Range") {
              label = "customrange";
            }
            const dateFrom = stringToDateWithFormat(fromDate);
            const dateEnd = stringToDateWithFormat(endDate);
            const dateFromMoment = moment(dateFrom).format(YYYY_MM_DD_HH_MM_SS);
            const dateEndMoment = moment(dateEnd).format(YYYY_MM_DD_HH_MM_SS);
            const chartFtr = {
              transactionDate: label.toLowerCase(),
              dateFilterLabel: chosenLabel,
              dateFrom: dateFromMoment,
              dateTo: dateEndMoment
            };
            setChartFilter(chartFtr);
            applyFilter(chartFtr);
          }}
          initialSettings={{
            startDate: moment().startOf("month"),
            endDate: moment().endOf("month"),
            ranges: customRangeReportWithoutDays,
            opens: "left",
            applyButtonClasses: "btn btn-brand",
            showCustomRangeLabel: false
          }}
        >
          <Button variant="btn btn-brand font-weight-bolder btn-md">
            <span className="svg-icon svg-icon-sm svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/General/Calendar.svg")}
              ></SVG>
            </span>
            {chartFilter.dateFilterLabel}
            {chartLoading && (
              <span className="ml-1 mr-3 spinner spinner-white"></span>
            )}
          </Button>
        </DateRangePicker>
      </Card.Header>

      <Card.Body>
        <div className="d-flex justify-content-center">
          <div style={{ width: "650px" }}>
            <Line options={options} data={datas} />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TransactionsReportChart;
